import {Plural, Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler, HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {computeMultiSelectCheckboxState} from '../../components/common/table/helpers/tableHelpers';
import {TableMultiSelectHeaderRow} from '../../components/common/table/tableMultiSelectHeaderRow';

/*
 * Props.
 */

interface SettingsTagsMultiSelectHeaderProps {
  onMultiSelectChange: HandlerOf<boolean>;
  selectedTagIds: ReadonlyArray<number>;
  numberOfTagsInList: number;
  isInArchivedView: boolean;
  onNestClick: Handler;
  onCancelClick: Handler;
  onDeleteClick: Handler;
  onArchiveClick: Handler;
  onRestoreClick: Handler;
}

/*
 * Style.
 */

const StyledButtonsWrapper = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
`;

/*
 * Component.
 */

export const SettingsTagsMultiSelectHeader: FC<SettingsTagsMultiSelectHeaderProps> = (props) => {
  const {
    onMultiSelectChange,
    selectedTagIds,
    numberOfTagsInList,
    isInArchivedView,
    onNestClick,
    onCancelClick,
    onDeleteClick,
    onArchiveClick,
    onRestoreClick,
  } = props;

  const multiSelectCheckboxState = computeMultiSelectCheckboxState(selectedTagIds.length, numberOfTagsInList);

  const renderButtons = () => {
    if (isInArchivedView) {
      return (
        <StyledButtonsWrapper>
          <Button variant={ButtonVariantsEnum.SECONDARY_DANGER} onClick={onDeleteClick}>
            <Trans id="settingstags-bulk-delete">Delete</Trans>
          </Button>
          <Button onClick={onRestoreClick}>
            <Trans id="settingstags-bulk-restore">Restore</Trans>
          </Button>
          <Button onClick={onCancelClick}>
            <Trans id="settingstags-bulk-cancel">Cancel</Trans>
          </Button>
        </StyledButtonsWrapper>
      );
    }

    return (
      <StyledButtonsWrapper>
        <Button onClick={onNestClick}>
          <Trans id="settingstags-bulk-nest">Nest</Trans>
        </Button>
        <Button onClick={onArchiveClick}>
          <Trans id="settingstags-bulk-archive">Archive</Trans>
        </Button>
        <Button variant={ButtonVariantsEnum.SECONDARY_DANGER} onClick={onDeleteClick}>
          <Trans id="settingstags-bulk-delete">Delete</Trans>
        </Button>
      </StyledButtonsWrapper>
    );
  };

  return (
    <TableMultiSelectHeaderRow
      multiSelectStatus={multiSelectCheckboxState}
      onMultiSelectChange={onMultiSelectChange}
      renderTotalItemsLabel={() => (
        <Plural
          id="settings-tags-bulkactiontagsselected"
          value={selectedTagIds.length}
          zero="No tags selected"
          one="1 tag selected"
          other="# tags selected"
        />
      )}
    >
      {renderButtons()}
    </TableMultiSelectHeaderRow>
  );
};
